// Daily Output (37_CapacityOutput.jsx, OutputCellPicker.jsx) — the screen's strings in the portal's four languages (2026-10-21).
// Values the code reads (the part 'Skin' / 'Case', vendor codes, PO numbers, item names, slot hours) are data and are
// not here; only what the reader is shown. "Capacity Management" is the workbook's own name and stays as written.
const en = {
  // errors shown when the server gives no message of its own
  failed: 'Failed ({{status}})',
  loadFailed: 'Load failed ({{status}})',
  saveFailed: 'Save failed ({{status}})',
  couldNotAdd: 'Could not add ({{status}})',
  couldNotChangeItem: 'Could not change the item ({{status}})',
  couldNotAttach: 'Could not attach ({{status}})',
  couldNotMark: 'Could not mark it ({{status}})',
  couldNotRemove: 'Could not remove ({{status}})',
  rowWord: 'row',
  attachSummary: '{{done}} attached; {{failed}} could not be: {{list}}',

  // a row whose stored total is not the hour boxes
  gapDiff: 'The row stores {{stored}} pcs, but the hour boxes add up to {{sum}} pcs. Worth checking.',
  gapOpening: "Opening balance carried over from the Capacity Management file: {{stored}} pcs.\nIt is not this day's output, so it is not added to the day total — but Capacity still counts it as made.",
  gapNoHours: 'This row stores {{stored}} pcs with NO hourly detail behind it, so it is not part of the day total.\nFill the hour boxes and the figure counts.',

  // the sheet list's "Needs checking" column (also its funnel values)
  chkNotAddUp: 'Does not add up',
  chkOpening: 'Opening balance',
  chkNoHourly: 'No hourly detail',
  chkUnmatched: 'Unmatched rows',
  daysWithNothing_one: '{{count}} day with nothing',
  daysWithNothing_other: '{{count}} days with nothing',

  // the step picker and the column names
  stepMonth: 'Month Shipment',
  colMonth: 'Month',
  colPo: 'PO#',
  colDescription: 'Description',
  colColour: 'Colour',
  colSkinCase: 'Skin/Case',
  colOrder: 'Order',
  colLine: 'Line #',
  colWorkers: 'Workers',
  colHrs: 'Hrs',
  colTotal: 'Total',
  colRemain: 'Remain',
  colEff: 'Eff.',
  choose: 'Choose',
  loading: 'Loading…',
  nothingLeft: 'Nothing left to choose here.',
  blank: '(blank)',
  leftOf: '{{left}} left of {{order}}',
  destinations: '{{n}} destinations',

  // the Unmatched panel
  unTitle: 'Not matched to an order',
  unRows: '{{total}} rows',
  unItems: '{{n}} items',
  unItemsOf: '{{shown}} / {{n}} items',
  unLargest: '(showing the {{n}} largest)',
  clearFilterTitle: 'Clear the filter',
  filteredBtn: 'filtered',
  unNote: "Output that is really in the factory's file but that the portal could not attach to an order. Nothing is guessed: attaching it to the wrong order would add the hours to the wrong job.",
  nothingUnmatched: 'Nothing is left unmatched.',
  colVendor: 'Vendor',
  colFileDescription: 'Description in the factory file',
  colWhy: 'Why it did not match',
  colPcs: 'pcs',
  colDays: 'Days',
  colLastSeen: 'Last seen',
  markDealtWith: 'Mark as dealt with',
  nothingMatchesFilter: 'Nothing matches this filter.',

  // the list of sheets
  sheetsTitle: 'Sheets filled in',
  sheetDays_one: '{{count}} day',
  sheetDays_other: '{{count}} days',
  sheetMonths_one: '{{count}} month',
  sheetMonths_other: '{{count}} months',
  issuesTitle: 'Only the days holding a row that does not add up, or a figure with no hourly detail',
  issuesOnlyOn: 'only what needs checking',
  issuesCount: 'needs checking · {{n}}',
  noSheets: 'This vendor has not filled in a sheet yet.',
  colDate: 'Date',
  colRows: 'Rows',
  colOutput: 'Output',
  colWorkHours: 'Work hours',
  colLines: 'Lines',
  colNeedsChecking: 'Needs checking',
  colSinceBefore: 'Since the sheet before',
  colEnteredBy: 'Entered by',
  todayTag: 'today',
  gapMarkTitle: '{{rows}} row(s) store {{qty}} pcs between them with no hourly detail behind them, so they are not in the Output column.',
  gapMarkAllOpening: 'All of it is opening balance carried over from the Capacity Management file.',
  gapMarkOpening_one: '{{count}} row · {{qty}} pcs opening balance',
  gapMarkOpening_other: '{{count}} rows · {{qty}} pcs opening balance',
  gapMarkNoHourly_one: '{{count}} row · {{qty}} pcs with no hourly detail',
  gapMarkNoHourly_other: '{{count}} rows · {{qty}} pcs with no hourly detail',
  diffTitle: '{{n}} row(s) store a total that is not what the hour boxes add up to.',
  diffText_one: '{{count}} row does not add up',
  diffText_other: '{{count}} rows do not add up',
  unmarkTitle: "{{n}} row(s) in the factory's file for this day, {{qty}} pcs, could not be attached to an order — see Unmatched.",
  unmarkText: '{{n}} unmatched · {{qty}} pcs',

  // the page
  title: 'Daily Output',
  intro: 'What each line produced, hour by hour. Pick the item from the order list — the description, colour and quantity then come from Helinox, so the figures land in the right place.',
  chooseVendor: 'Choose a vendor…',
  notLinked: 'This login is not linked to a vendor yet, so there is nothing to show.',
  chooseVendorToSee: 'Choose a vendor to see its output.',
  todayBtn: 'Today',
  sheetsBtnTitle: 'The days this vendor has filled a sheet in for',
  checkBtnTitle: "What in this vendor's rows cannot be measured with — pieces with no hours, a line's hours over a day, hours split evenly — and what to fix first",
  checkBtn: 'Data check',
  hourBoxesAdded: 'the hour boxes added up',
  rowsN_one: '{{count}} row',
  rowsN_other: '{{count}} rows',
  workHoursN: '{{n}} work hours',
  filteredClear: 'Filtered — clear',
  sortedClear: 'Sorted — clear',
  unNoteTitle: "Rows in the factory's file for this day that could not be attached to an order.\nThey are drawn under the sheet in red and are NOT in the total above. Unlock the table to attach one to an order, or mark it dealt with.",
  unNoteText: '{{n}} not matched · {{qty}} pcs, under the sheet',
  attachAllTitle: 'Attach every not-matched row whose five cells are all filled in, each to the order its cells show.\nCheck the blue (guessed) cells first — nothing is written until you press this.',
  attaching: 'Attaching…',
  attachFilled_one: 'Attach {{count}} filled-in row',
  attachFilled_other: 'Attach {{count}} filled-in rows',
  earlierMore: '{{dates}} and {{n}} more',
  earlierDays_one: '{{count}} earlier day needs checking',
  earlierDays_other: '{{count}} earlier days need checking',
  gapNoteTitle: 'The day total is the hour boxes added up.\nThese rows store a figure with no hourly detail behind it, so it is NOT in the total. Fill the hour boxes and it counts.',
  gapNote_one: '{{count}} row with no hourly detail · {{qty}} pcs not counted',
  gapNote_other: '{{count}} rows with no hourly detail · {{qty}} pcs not counted',
  openingParen: '(opening balance)',
  editTableTitle: 'Unlock the table, change as much as you like, then save it in one press',
  editTable: 'Edit the table',
  saving: 'Saving…',
  saveTable: 'Save the table',
  saveTableN_one: 'Save the table ({{count}} row)',
  saveTableN_other: 'Save the table ({{count}} rows)',
  cancel: 'Cancel',
  unmatchedBtnTitle: 'Rows in the factory file that could not be attached to an order',
  unmatchedBtn: 'Unmatched',
  reload: 'Reload',
  // <b>…</b> is drawn bold (Trans).
  bulkHint: 'The table is unlocked — type freely, nothing is written until you press <b>Save the table</b>. It saves in one go: either all of it lands or nothing changes. Picking an item on a blank row adds that row straight away.',

  // the rows
  searchDescription: 'Search description…',
  inTheFile: 'In the file',
  notMatched: 'Not matched',
  chooseFirst: 'Choose Month, PO#, Description and Colour first',
  filePo: 'File PO: {{po}}',
  fileLabel: 'File: {{file}}',
  pickAgainTitle: 'Chose the wrong item? Click to pick again — the hours stay.',
  confirmTypeHours: 'This row stores {{qty}} pcs with no hourly detail.\nTyping by the hour replaces that figure with the hour boxes added up — so fill in the whole day. Continue?',
  opShort: 'op',
  removeRowTitle: 'Remove this row',
  confirmRemove: 'Remove {{what}} ({{part}}) from {{date}}?',
  confirmLeave: '{{n}} row(s) have unsaved changes. Leaving this day throws them away. Continue?',
  confirmDiscard: 'Throw away the unsaved changes on {{n}} row(s)?',
  confirmAttachAll: 'Attach {{n}} row(s) to the order shown on each?',
  confirmAttachOver: '{{over}} of them take their order over what it has left.',
  attachTitle: 'Attach {{qty}} pcs to {{po}} · {{description}} · {{colour}} · {{part}}',
  attachOverTitle: 'This order has {{left}} of {{order}} left — attaching takes it over.',
  attach: 'Attach',
  clearChosenTitle: 'Clear what was chosen on this row',
  dismissTitle: 'Dealt with, not attached — for a row that belongs on no order. It leaves this sheet and the Unmatched list and is NOT recorded as output.',
  clearLower: 'clear',
  nothingEntered: 'Nothing entered for {{date}}.',

  // one cell's search box (OutputCellPicker)
  guessedLoose: '{{value}} — guessed from a similar name, check it',
  guessedFile: "{{value}} — suggested from the vendor's file",
  thisCell: 'This cell',
  copyTitle: 'Copy "{{text}}"',
  copied: 'Copied',
  copy: 'Copy',
  emptyCellTitle: 'Empty this cell',
  clear: 'Clear',
  nothingMatchesShorter: 'Nothing matches — try a shorter word.',
  otherChoices: 'Other choices',
  otherChoicesWith: 'Other choices with {{what}}',
  pickingClears: 'picking one clears {{fields}}',
  andJoin: ' and ',
};

const ko = {
  failed: '실패 ({{status}})',
  loadFailed: '불러오기 실패 ({{status}})',
  saveFailed: '저장 실패 ({{status}})',
  couldNotAdd: '추가하지 못했습니다 ({{status}})',
  couldNotChangeItem: '품목을 변경하지 못했습니다 ({{status}})',
  couldNotAttach: '연결하지 못했습니다 ({{status}})',
  couldNotMark: '처리 표시를 하지 못했습니다 ({{status}})',
  couldNotRemove: '삭제하지 못했습니다 ({{status}})',
  rowWord: '행',
  attachSummary: '{{done}}행 연결됨, {{failed}}행 연결 실패: {{list}}',

  gapDiff: '이 행에는 {{stored}} pcs가 저장되어 있지만 시간대별 칸의 합계는 {{sum}} pcs입니다. 확인이 필요합니다.',
  gapOpening: 'Capacity Management 파일에서 이월된 기초 잔량: {{stored}} pcs.\n이 날의 생산량이 아니므로 일 합계에 더하지 않지만, 생산 능력 화면에서는 생산된 것으로 계산합니다.',
  gapNoHours: '이 행에는 시간대별 내역 없이 {{stored}} pcs가 저장되어 있어 일 합계에 포함되지 않습니다.\n시간대별 칸을 채우면 수량이 반영됩니다.',

  chkNotAddUp: '합계 불일치',
  chkOpening: '기초 잔량',
  chkNoHourly: '시간대별 내역 없음',
  chkUnmatched: '미매칭 행',
  daysWithNothing_one: '입력 없는 날 {{count}}일',
  daysWithNothing_other: '입력 없는 날 {{count}}일',

  stepMonth: '선적 월',
  colMonth: '월',
  colPo: 'PO#',
  colDescription: '품명',
  colColour: '색상',
  colSkinCase: 'Skin/Case',
  colOrder: '오더',
  colLine: '라인 #',
  colWorkers: '작업자',
  colHrs: '시간',
  colTotal: '합계',
  colRemain: '잔량',
  colEff: '효율',
  choose: '선택',
  loading: '불러오는 중…',
  nothingLeft: '선택할 항목이 없습니다.',
  blank: '(공란)',
  leftOf: '{{order}} 중 {{left}} 남음',
  destinations: '도착지 {{n}}곳',

  unTitle: '오더에 매칭되지 않음',
  unRows: '{{total}}행',
  unItems: '{{n}}개 품목',
  unItemsOf: '{{shown}} / {{n}}개 품목',
  unLargest: '(상위 {{n}}개 표시)',
  clearFilterTitle: '필터 해제',
  filteredBtn: '필터 적용됨',
  unNote: '공장 파일에는 실제로 있지만 포털이 오더에 연결하지 못한 생산량입니다. 추측으로 연결하지 않습니다: 잘못된 오더에 연결하면 시간이 다른 작업에 더해집니다.',
  nothingUnmatched: '매칭되지 않은 항목이 없습니다.',
  colVendor: '벤더',
  colFileDescription: '공장 파일의 품명',
  colWhy: '매칭되지 않은 이유',
  colPcs: 'pcs',
  colDays: '일수',
  colLastSeen: '마지막 확인일',
  markDealtWith: '처리 완료로 표시',
  nothingMatchesFilter: '이 필터에 맞는 항목이 없습니다.',

  sheetsTitle: '입력된 시트',
  sheetDays_one: '{{count}}일',
  sheetDays_other: '{{count}}일',
  sheetMonths_one: '{{count}}개월',
  sheetMonths_other: '{{count}}개월',
  issuesTitle: '합계가 맞지 않는 행이나 시간대별 내역 없는 수량이 있는 날만',
  issuesOnlyOn: '확인 필요 항목만',
  issuesCount: '확인 필요 · {{n}}',
  noSheets: '이 벤더는 아직 시트를 입력하지 않았습니다.',
  colDate: '날짜',
  colRows: '행',
  colOutput: '생산량',
  colWorkHours: '작업 시간',
  colLines: '라인',
  colNeedsChecking: '확인 필요',
  colSinceBefore: '이전 시트 이후',
  colEnteredBy: '입력자',
  todayTag: '오늘',
  gapMarkTitle: '{{rows}}개 행에 시간대별 내역 없이 합계 {{qty}} pcs가 저장되어 있어 생산량 열에 포함되지 않습니다.',
  gapMarkAllOpening: '모두 Capacity Management 파일에서 이월된 기초 잔량입니다.',
  gapMarkOpening_one: '{{count}}행 · {{qty}} pcs 기초 잔량',
  gapMarkOpening_other: '{{count}}행 · {{qty}} pcs 기초 잔량',
  gapMarkNoHourly_one: '{{count}}행 · {{qty}} pcs 시간대별 내역 없음',
  gapMarkNoHourly_other: '{{count}}행 · {{qty}} pcs 시간대별 내역 없음',
  diffTitle: '{{n}}개 행에 저장된 합계가 시간대별 칸의 합과 다릅니다.',
  diffText_one: '{{count}}행 합계 불일치',
  diffText_other: '{{count}}행 합계 불일치',
  unmarkTitle: '이 날 공장 파일의 {{n}}개 행, {{qty}} pcs를 오더에 연결하지 못했습니다 — 미매칭을 확인하세요.',
  unmarkText: '미매칭 {{n}} · {{qty}} pcs',

  title: '일일 생산량',
  intro: '각 라인이 시간대별로 생산한 수량입니다. 오더 목록에서 품목을 선택하면 품명, 색상, 수량은 Helinox 데이터에서 가져오므로 수치가 정확한 곳에 반영됩니다.',
  chooseVendor: '벤더 선택…',
  notLinked: '이 로그인은 아직 벤더에 연결되지 않아 표시할 내용이 없습니다.',
  chooseVendorToSee: '생산량을 보려면 벤더를 선택하세요.',
  todayBtn: '오늘',
  sheetsBtnTitle: '이 벤더가 시트를 입력한 날짜',
  checkBtnTitle: '이 벤더의 행 중 측정에 쓸 수 없는 것 — 시간 없는 수량, 하루를 넘는 라인 시간, 균등 분할된 시간 — 과 먼저 고칠 것',
  checkBtn: '데이터 점검',
  hourBoxesAdded: '시간대별 칸 합계',
  rowsN_one: '{{count}}행',
  rowsN_other: '{{count}}행',
  workHoursN: '작업 시간 {{n}}',
  filteredClear: '필터 적용 — 해제',
  sortedClear: '정렬 적용 — 해제',
  unNoteTitle: '이 날 공장 파일에서 오더에 연결하지 못한 행입니다.\n시트 아래에 빨간색으로 표시되며 위 합계에 포함되지 않습니다. 표 잠금을 해제하면 오더에 연결하거나 처리 완료로 표시할 수 있습니다.',
  unNoteText: '미매칭 {{n}} · {{qty}} pcs, 시트 아래',
  attachAllTitle: '다섯 칸이 모두 채워진 미매칭 행을 각 칸이 가리키는 오더에 모두 연결합니다.\n파란색(추정) 칸을 먼저 확인하세요 — 이 버튼을 누르기 전에는 아무것도 저장되지 않습니다.',
  attaching: '연결 중…',
  attachFilled_one: '입력 완료된 {{count}}행 연결',
  attachFilled_other: '입력 완료된 {{count}}행 연결',
  earlierMore: '{{dates}} 외 {{n}}일',
  earlierDays_one: '이전 {{count}}일 확인 필요',
  earlierDays_other: '이전 {{count}}일 확인 필요',
  gapNoteTitle: '일 합계는 시간대별 칸의 합입니다.\n이 행들은 시간대별 내역 없이 수량만 저장되어 있어 합계에 포함되지 않습니다. 시간대별 칸을 채우면 반영됩니다.',
  gapNote_one: '시간대별 내역 없는 행 {{count}}개 · {{qty}} pcs 미반영',
  gapNote_other: '시간대별 내역 없는 행 {{count}}개 · {{qty}} pcs 미반영',
  openingParen: '(기초 잔량)',
  editTableTitle: '표 잠금을 해제하고 원하는 만큼 수정한 뒤 한 번에 저장합니다',
  editTable: '표 수정',
  saving: '저장 중…',
  saveTable: '표 저장',
  saveTableN_one: '표 저장 ({{count}}행)',
  saveTableN_other: '표 저장 ({{count}}행)',
  cancel: '취소',
  unmatchedBtnTitle: '공장 파일에서 오더에 연결하지 못한 행',
  unmatchedBtn: '미매칭',
  reload: '새로고침',
  bulkHint: '표 잠금이 해제되었습니다 — 자유롭게 입력하세요. <b>표 저장</b>을 누르기 전에는 아무것도 저장되지 않습니다. 한 번에 저장되므로 전부 반영되거나 아무것도 바뀌지 않습니다. 빈 행에서 품목을 선택하면 그 행은 바로 추가됩니다.',

  searchDescription: '품명 검색…',
  inTheFile: '파일 원문',
  notMatched: '미매칭',
  chooseFirst: '월, PO#, 품명, 색상을 먼저 선택하세요',
  filePo: '파일 PO: {{po}}',
  fileLabel: '파일: {{file}}',
  pickAgainTitle: '품목을 잘못 선택했나요? 클릭해서 다시 고르세요 — 시간은 그대로 유지됩니다.',
  confirmTypeHours: '이 행에는 시간대별 내역 없이 {{qty}} pcs가 저장되어 있습니다.\n시간대별로 입력하면 그 수치가 시간대별 칸의 합으로 바뀝니다 — 하루 전체를 입력하세요. 계속할까요?',
  opShort: '기초',
  removeRowTitle: '이 행 삭제',
  confirmRemove: '{{date}}에서 {{what}} ({{part}})을(를) 삭제할까요?',
  confirmLeave: '{{n}}개 행에 저장하지 않은 변경이 있습니다. 이 날을 벗어나면 사라집니다. 계속할까요?',
  confirmDiscard: '{{n}}개 행의 저장하지 않은 변경을 버릴까요?',
  confirmAttachAll: '{{n}}개 행을 각 행에 표시된 오더에 연결할까요?',
  confirmAttachOver: '그중 {{over}}개 행은 오더의 남은 수량을 초과합니다.',
  attachTitle: '{{qty}} pcs를 {{po}} · {{description}} · {{colour}} · {{part}}에 연결',
  attachOverTitle: '이 오더는 {{order}} 중 {{left}} 남아 있습니다 — 연결하면 초과됩니다.',
  attach: '연결',
  clearChosenTitle: '이 행에서 선택한 값 지우기',
  dismissTitle: '연결하지 않고 처리 완료 — 어느 오더에도 속하지 않는 행용입니다. 이 시트와 미매칭 목록에서 빠지며 생산량으로 기록되지 않습니다.',
  clearLower: '지우기',
  nothingEntered: '{{date}}에 입력된 내용이 없습니다.',

  guessedLoose: '{{value}} — 비슷한 이름으로 추정, 확인 필요',
  guessedFile: '{{value}} — 벤더 파일 기준 제안',
  thisCell: '이 칸',
  copyTitle: '"{{text}}" 복사',
  copied: '복사됨',
  copy: '복사',
  emptyCellTitle: '이 칸 비우기',
  clear: '지우기',
  nothingMatchesShorter: '일치하는 항목이 없습니다 — 더 짧은 단어로 검색해 보세요.',
  otherChoices: '다른 선택지',
  otherChoicesWith: '{{what}} 기준 다른 선택지',
  pickingClears: '선택하면 {{fields}} 값이 지워집니다',
  andJoin: ' 및 ',
};

const vi = {
  failed: 'Lỗi ({{status}})',
  loadFailed: 'Tải thất bại ({{status}})',
  saveFailed: 'Lưu thất bại ({{status}})',
  couldNotAdd: 'Không thêm được ({{status}})',
  couldNotChangeItem: 'Không đổi được mặt hàng ({{status}})',
  couldNotAttach: 'Không gắn được ({{status}})',
  couldNotMark: 'Không đánh dấu được ({{status}})',
  couldNotRemove: 'Không xóa được ({{status}})',
  rowWord: 'dòng',
  attachSummary: 'Đã gắn {{done}} dòng; {{failed}} dòng không gắn được: {{list}}',

  gapDiff: 'Dòng này lưu {{stored}} pcs, nhưng các ô theo giờ cộng lại là {{sum}} pcs. Nên kiểm tra lại.',
  gapOpening: 'Số dư đầu kỳ chuyển từ file Capacity Management: {{stored}} pcs.\nĐây không phải sản lượng của ngày này nên không cộng vào tổng ngày — nhưng màn hình Năng lực sản xuất vẫn tính là đã làm.',
  gapNoHours: 'Dòng này lưu {{stored}} pcs mà KHÔNG có chi tiết theo giờ, nên không tính vào tổng ngày.\nĐiền các ô theo giờ thì số này mới được tính.',

  chkNotAddUp: 'Không khớp tổng',
  chkOpening: 'Số dư đầu kỳ',
  chkNoHourly: 'Không có chi tiết theo giờ',
  chkUnmatched: 'Dòng chưa khớp',
  daysWithNothing_one: '{{count}} ngày không có gì',
  daysWithNothing_other: '{{count}} ngày không có gì',

  stepMonth: 'Tháng giao hàng',
  colMonth: 'Tháng',
  colPo: 'PO#',
  colDescription: 'Mô tả',
  colColour: 'Màu',
  colSkinCase: 'Skin/Case',
  colOrder: 'Đơn',
  colLine: 'Chuyền #',
  colWorkers: 'Công nhân',
  colHrs: 'Giờ',
  colTotal: 'Tổng',
  colRemain: 'Còn lại',
  colEff: 'H.suất',
  choose: 'Chọn',
  loading: 'Đang tải…',
  nothingLeft: 'Không còn gì để chọn.',
  blank: '(trống)',
  leftOf: 'còn {{left}} / {{order}}',
  destinations: '{{n}} điểm đến',

  unTitle: 'Chưa khớp với đơn hàng',
  unRows: '{{total}} dòng',
  unItems: '{{n}} mặt hàng',
  unItemsOf: '{{shown}} / {{n}} mặt hàng',
  unLargest: '(hiện {{n}} mặt hàng lớn nhất)',
  clearFilterTitle: 'Bỏ lọc',
  filteredBtn: 'đang lọc',
  unNote: 'Sản lượng có thật trong file của nhà máy nhưng portal không gắn được vào đơn hàng nào. Không đoán mò: gắn nhầm đơn sẽ cộng giờ vào nhầm việc.',
  nothingUnmatched: 'Không còn dòng nào chưa khớp.',
  colVendor: 'Nhà cung cấp',
  colFileDescription: 'Mô tả trong file nhà máy',
  colWhy: 'Lý do không khớp',
  colPcs: 'pcs',
  colDays: 'Số ngày',
  colLastSeen: 'Lần cuối',
  markDealtWith: 'Đánh dấu đã xử lý',
  nothingMatchesFilter: 'Không có mục nào khớp bộ lọc này.',

  sheetsTitle: 'Các phiếu đã điền',
  sheetDays_one: '{{count}} ngày',
  sheetDays_other: '{{count}} ngày',
  sheetMonths_one: '{{count}} tháng',
  sheetMonths_other: '{{count}} tháng',
  issuesTitle: 'Chỉ những ngày có dòng không khớp tổng, hoặc có số liệu không có chi tiết theo giờ',
  issuesOnlyOn: 'chỉ mục cần kiểm tra',
  issuesCount: 'cần kiểm tra · {{n}}',
  noSheets: 'Nhà cung cấp này chưa điền phiếu nào.',
  colDate: 'Ngày',
  colRows: 'Dòng',
  colOutput: 'Sản lượng',
  colWorkHours: 'Giờ công',
  colLines: 'Chuyền',
  colNeedsChecking: 'Cần kiểm tra',
  colSinceBefore: 'Từ phiếu trước',
  colEnteredBy: 'Người nhập',
  todayTag: 'hôm nay',
  gapMarkTitle: '{{rows}} dòng lưu tổng cộng {{qty}} pcs mà không có chi tiết theo giờ, nên không nằm trong cột Sản lượng.',
  gapMarkAllOpening: 'Toàn bộ là số dư đầu kỳ chuyển từ file Capacity Management.',
  gapMarkOpening_one: '{{count}} dòng · {{qty}} pcs số dư đầu kỳ',
  gapMarkOpening_other: '{{count}} dòng · {{qty}} pcs số dư đầu kỳ',
  gapMarkNoHourly_one: '{{count}} dòng · {{qty}} pcs không có chi tiết theo giờ',
  gapMarkNoHourly_other: '{{count}} dòng · {{qty}} pcs không có chi tiết theo giờ',
  diffTitle: '{{n}} dòng lưu tổng khác với tổng các ô theo giờ.',
  diffText_one: '{{count}} dòng không khớp tổng',
  diffText_other: '{{count}} dòng không khớp tổng',
  unmarkTitle: '{{n}} dòng trong file nhà máy của ngày này, {{qty}} pcs, không gắn được vào đơn hàng — xem mục Chưa khớp.',
  unmarkText: '{{n}} chưa khớp · {{qty}} pcs',

  title: 'Sản lượng hằng ngày',
  intro: 'Sản lượng từng chuyền theo từng giờ. Chọn mặt hàng từ danh sách đơn hàng — mô tả, màu và số lượng sẽ lấy từ Helinox, nên số liệu vào đúng chỗ.',
  chooseVendor: 'Chọn nhà cung cấp…',
  notLinked: 'Tài khoản này chưa được gắn với nhà cung cấp nào, nên không có gì để hiển thị.',
  chooseVendorToSee: 'Chọn nhà cung cấp để xem sản lượng.',
  todayBtn: 'Hôm nay',
  sheetsBtnTitle: 'Những ngày nhà cung cấp này đã điền phiếu',
  checkBtnTitle: 'Những gì trong các dòng của nhà cung cấp này không dùng để đo được — số lượng không có giờ, giờ của chuyền vượt quá một ngày, giờ chia đều — và cần sửa gì trước',
  checkBtn: 'Kiểm tra dữ liệu',
  hourBoxesAdded: 'tổng các ô theo giờ',
  rowsN_one: '{{count}} dòng',
  rowsN_other: '{{count}} dòng',
  workHoursN: '{{n}} giờ công',
  filteredClear: 'Đang lọc — bỏ lọc',
  sortedClear: 'Đang sắp xếp — bỏ',
  unNoteTitle: 'Các dòng trong file nhà máy của ngày này không gắn được vào đơn hàng.\nChúng hiện bên dưới phiếu bằng màu đỏ và KHÔNG nằm trong tổng ở trên. Mở khóa bảng để gắn vào đơn hàng, hoặc đánh dấu đã xử lý.',
  unNoteText: '{{n}} chưa khớp · {{qty}} pcs, bên dưới phiếu',
  attachAllTitle: 'Gắn mọi dòng chưa khớp đã điền đủ năm ô, mỗi dòng vào đơn hàng mà các ô của nó chỉ ra.\nKiểm tra các ô màu xanh (đoán) trước — không có gì được ghi cho đến khi bấm nút này.',
  attaching: 'Đang gắn…',
  attachFilled_one: 'Gắn {{count}} dòng đã điền',
  attachFilled_other: 'Gắn {{count}} dòng đã điền',
  earlierMore: '{{dates}} và {{n}} ngày khác',
  earlierDays_one: '{{count}} ngày trước cần kiểm tra',
  earlierDays_other: '{{count}} ngày trước cần kiểm tra',
  gapNoteTitle: 'Tổng ngày là tổng các ô theo giờ.\nCác dòng này lưu số liệu không có chi tiết theo giờ, nên KHÔNG nằm trong tổng. Điền các ô theo giờ thì mới được tính.',
  gapNote_one: '{{count}} dòng không có chi tiết theo giờ · {{qty}} pcs không được tính',
  gapNote_other: '{{count}} dòng không có chi tiết theo giờ · {{qty}} pcs không được tính',
  openingParen: '(số dư đầu kỳ)',
  editTableTitle: 'Mở khóa bảng, sửa bao nhiêu tùy ý, rồi lưu một lần',
  editTable: 'Sửa bảng',
  saving: 'Đang lưu…',
  saveTable: 'Lưu bảng',
  saveTableN_one: 'Lưu bảng ({{count}} dòng)',
  saveTableN_other: 'Lưu bảng ({{count}} dòng)',
  cancel: 'Hủy',
  unmatchedBtnTitle: 'Các dòng trong file nhà máy không gắn được vào đơn hàng',
  unmatchedBtn: 'Chưa khớp',
  reload: 'Tải lại',
  bulkHint: 'Bảng đã mở khóa — cứ nhập thoải mái, không có gì được ghi cho đến khi bấm <b>Lưu bảng</b>. Lưu một lần: hoặc toàn bộ được ghi, hoặc không có gì thay đổi. Chọn mặt hàng ở dòng trống sẽ thêm dòng đó ngay.',

  searchDescription: 'Tìm mô tả…',
  inTheFile: 'Trong file',
  notMatched: 'Chưa khớp',
  chooseFirst: 'Chọn Tháng, PO#, Mô tả và Màu trước',
  filePo: 'PO trong file: {{po}}',
  fileLabel: 'File: {{file}}',
  pickAgainTitle: 'Chọn nhầm mặt hàng? Bấm để chọn lại — giờ vẫn giữ nguyên.',
  confirmTypeHours: 'Dòng này lưu {{qty}} pcs mà không có chi tiết theo giờ.\nNhập theo giờ sẽ thay số đó bằng tổng các ô theo giờ — hãy điền cả ngày. Tiếp tục?',
  opShort: 'đầu kỳ',
  removeRowTitle: 'Xóa dòng này',
  confirmRemove: 'Xóa {{what}} ({{part}}) khỏi ngày {{date}}?',
  confirmLeave: '{{n}} dòng có thay đổi chưa lưu. Rời ngày này sẽ mất các thay đổi đó. Tiếp tục?',
  confirmDiscard: 'Bỏ các thay đổi chưa lưu trên {{n}} dòng?',
  confirmAttachAll: 'Gắn {{n}} dòng vào đơn hàng hiện trên từng dòng?',
  confirmAttachOver: '{{over}} dòng trong số đó làm vượt số lượng còn lại của đơn.',
  attachTitle: 'Gắn {{qty}} pcs vào {{po}} · {{description}} · {{colour}} · {{part}}',
  attachOverTitle: 'Đơn này còn {{left}} / {{order}} — gắn vào sẽ vượt.',
  attach: 'Gắn',
  clearChosenTitle: 'Xóa những gì đã chọn ở dòng này',
  dismissTitle: 'Đã xử lý, không gắn — dành cho dòng không thuộc đơn hàng nào. Dòng sẽ rời khỏi phiếu này và danh sách Chưa khớp, và KHÔNG được ghi nhận là sản lượng.',
  clearLower: 'xóa',
  nothingEntered: 'Chưa có gì được nhập cho ngày {{date}}.',

  guessedLoose: '{{value}} — đoán từ tên tương tự, cần kiểm tra',
  guessedFile: '{{value}} — gợi ý từ file của nhà cung cấp',
  thisCell: 'Ô này',
  copyTitle: 'Sao chép "{{text}}"',
  copied: 'Đã chép',
  copy: 'Sao chép',
  emptyCellTitle: 'Để trống ô này',
  clear: 'Xóa',
  nothingMatchesShorter: 'Không có kết quả — thử từ ngắn hơn.',
  otherChoices: 'Lựa chọn khác',
  otherChoicesWith: 'Lựa chọn khác với {{what}}',
  pickingClears: 'chọn một mục sẽ xóa {{fields}}',
  andJoin: ' và ',
};

const zh = {
  failed: '失败（{{status}}）',
  loadFailed: '加载失败（{{status}}）',
  saveFailed: '保存失败（{{status}}）',
  couldNotAdd: '无法添加（{{status}}）',
  couldNotChangeItem: '无法更改物料（{{status}}）',
  couldNotAttach: '无法关联（{{status}}）',
  couldNotMark: '无法标记（{{status}}）',
  couldNotRemove: '无法删除（{{status}}）',
  rowWord: '行',
  attachSummary: '已关联 {{done}} 行；{{failed}} 行未能关联：{{list}}',

  gapDiff: '该行存储 {{stored}} 件，但各小时格合计为 {{sum}} 件，请核对。',
  gapOpening: '从 Capacity Management 文件结转的期初余量：{{stored}} 件。\n这不是当天的产量，因此不计入当日合计 — 但产能页面仍按已生产计算。',
  gapNoHours: '该行存储 {{stored}} 件，但没有任何分小时明细，因此不计入当日合计。\n填写各小时格后才会计入。',

  chkNotAddUp: '合计不符',
  chkOpening: '期初余量',
  chkNoHourly: '无分小时明细',
  chkUnmatched: '未匹配行',
  daysWithNothing_one: '{{count}} 天无数据',
  daysWithNothing_other: '{{count}} 天无数据',

  stepMonth: '出货月份',
  colMonth: '月份',
  colPo: 'PO#',
  colDescription: '品名',
  colColour: '颜色',
  colSkinCase: 'Skin/Case',
  colOrder: '订单量',
  colLine: '产线 #',
  colWorkers: '工人',
  colHrs: '小时',
  colTotal: '合计',
  colRemain: '剩余',
  colEff: '效率',
  choose: '选择',
  loading: '加载中…',
  nothingLeft: '此处没有可选项。',
  blank: '（空白）',
  leftOf: '剩余 {{left}} / {{order}}',
  destinations: '{{n}} 个目的地',

  unTitle: '未匹配到订单',
  unRows: '{{total}} 行',
  unItems: '{{n}} 个品项',
  unItemsOf: '{{shown}} / {{n}} 个品项',
  unLargest: '（显示数量最多的 {{n}} 个）',
  clearFilterTitle: '清除筛选',
  filteredBtn: '已筛选',
  unNote: '工厂文件中确实存在、但系统无法关联到订单的产量。系统不做猜测：关联到错误的订单会把工时算到错误的工作上。',
  nothingUnmatched: '没有未匹配的项目。',
  colVendor: '供应商',
  colFileDescription: '工厂文件中的品名',
  colWhy: '未匹配原因',
  colPcs: '件',
  colDays: '天数',
  colLastSeen: '最近出现',
  markDealtWith: '标记为已处理',
  nothingMatchesFilter: '没有符合此筛选的项目。',

  sheetsTitle: '已填写的表单',
  sheetDays_one: '{{count}} 天',
  sheetDays_other: '{{count}} 天',
  sheetMonths_one: '{{count}} 个月',
  sheetMonths_other: '{{count}} 个月',
  issuesTitle: '仅显示含有合计不符的行，或含有无分小时明细数量的日期',
  issuesOnlyOn: '仅需核对项',
  issuesCount: '需核对 · {{n}}',
  noSheets: '该供应商尚未填写任何表单。',
  colDate: '日期',
  colRows: '行数',
  colOutput: '产量',
  colWorkHours: '工时',
  colLines: '产线',
  colNeedsChecking: '需核对',
  colSinceBefore: '距上一表单',
  colEnteredBy: '填写人',
  todayTag: '今天',
  gapMarkTitle: '{{rows}} 行共存储 {{qty}} 件，没有分小时明细，因此不计入产量列。',
  gapMarkAllOpening: '全部为从 Capacity Management 文件结转的期初余量。',
  gapMarkOpening_one: '{{count}} 行 · {{qty}} 件期初余量',
  gapMarkOpening_other: '{{count}} 行 · {{qty}} 件期初余量',
  gapMarkNoHourly_one: '{{count}} 行 · {{qty}} 件无分小时明细',
  gapMarkNoHourly_other: '{{count}} 行 · {{qty}} 件无分小时明细',
  diffTitle: '{{n}} 行存储的合计与各小时格之和不一致。',
  diffText_one: '{{count}} 行合计不符',
  diffText_other: '{{count}} 行合计不符',
  unmarkTitle: '当天工厂文件中有 {{n}} 行（{{qty}} 件）无法关联到订单 — 请查看“未匹配”。',
  unmarkText: '{{n}} 行未匹配 · {{qty}} 件',

  title: '每日产量',
  intro: '各产线逐小时的产量。从订单列表中选择物料 — 品名、颜色和数量随后取自 Helinox，确保数字记到正确的位置。',
  chooseVendor: '选择供应商…',
  notLinked: '此账号尚未关联供应商，因此没有可显示的内容。',
  chooseVendorToSee: '请选择供应商以查看其产量。',
  todayBtn: '今天',
  sheetsBtnTitle: '该供应商已填写表单的日期',
  checkBtnTitle: '该供应商的数据中无法用于测量的内容 — 无工时的件数、某产线一天内工时超标、平均分摊的工时 — 以及应优先修正的事项',
  checkBtn: '数据检查',
  hourBoxesAdded: '各小时格合计',
  rowsN_one: '{{count}} 行',
  rowsN_other: '{{count}} 行',
  workHoursN: '{{n}} 工时',
  filteredClear: '已筛选 — 清除',
  sortedClear: '已排序 — 清除',
  unNoteTitle: '当天工厂文件中无法关联到订单的行。\n它们以红色显示在表单下方，且不计入上方合计。解锁表格后可将其关联到订单，或标记为已处理。',
  unNoteText: '{{n}} 行未匹配 · {{qty}} 件，位于表单下方',
  attachAllTitle: '将五格均已填写的所有未匹配行，分别关联到其单元格所指的订单。\n请先核对蓝色（推测）的单元格 — 按下此按钮前不会写入任何内容。',
  attaching: '关联中…',
  attachFilled_one: '关联已填写的 {{count}} 行',
  attachFilled_other: '关联已填写的 {{count}} 行',
  earlierMore: '{{dates}}，另有 {{n}} 天',
  earlierDays_one: '之前有 {{count}} 天需要核对',
  earlierDays_other: '之前有 {{count}} 天需要核对',
  gapNoteTitle: '当日合计为各小时格之和。\n这些行存储的数量没有分小时明细，因此不计入合计。填写各小时格后即计入。',
  gapNote_one: '{{count}} 行无分小时明细 · {{qty}} 件未计入',
  gapNote_other: '{{count}} 行无分小时明细 · {{qty}} 件未计入',
  openingParen: '（期初余量）',
  editTableTitle: '解锁表格，随意修改，然后一次保存',
  editTable: '编辑表格',
  saving: '保存中…',
  saveTable: '保存表格',
  saveTableN_one: '保存表格（{{count}} 行）',
  saveTableN_other: '保存表格（{{count}} 行）',
  cancel: '取消',
  unmatchedBtnTitle: '工厂文件中无法关联到订单的行',
  unmatchedBtn: '未匹配',
  reload: '重新加载',
  bulkHint: '表格已解锁 — 可随意输入，按下<b>保存表格</b>之前不会写入任何内容。一次保存：要么全部写入，要么什么都不变。在空白行选择物料会立即添加该行。',

  searchDescription: '搜索品名…',
  inTheFile: '文件原文',
  notMatched: '未匹配',
  chooseFirst: '请先选择月份、PO#、品名和颜色',
  filePo: '文件中的 PO：{{po}}',
  fileLabel: '文件：{{file}}',
  pickAgainTitle: '选错物料了？点击重新选择 — 工时保持不变。',
  confirmTypeHours: '该行存储 {{qty}} 件，没有分小时明细。\n按小时输入会用各小时格之和替换该数字 — 请填写全天。是否继续？',
  opShort: '期初',
  removeRowTitle: '删除此行',
  confirmRemove: '从 {{date}} 删除 {{what}}（{{part}}）？',
  confirmLeave: '{{n}} 行有未保存的更改。离开这一天将丢弃这些更改。是否继续？',
  confirmDiscard: '放弃 {{n}} 行中未保存的更改？',
  confirmAttachAll: '将 {{n}} 行分别关联到各行显示的订单？',
  confirmAttachOver: '其中 {{over}} 行会使订单超出剩余数量。',
  attachTitle: '将 {{qty}} 件关联到 {{po}} · {{description}} · {{colour}} · {{part}}',
  attachOverTitle: '该订单剩余 {{left}} / {{order}} — 关联后将超出。',
  attach: '关联',
  clearChosenTitle: '清除此行已选的内容',
  dismissTitle: '已处理，不关联 — 用于不属于任何订单的行。它将从此表单和未匹配列表中移除，且不会记为产量。',
  clearLower: '清除',
  nothingEntered: '{{date}} 没有录入任何内容。',

  guessedLoose: '{{value}} — 按相似名称推测，请核对',
  guessedFile: '{{value}} — 根据供应商文件建议',
  thisCell: '此单元格',
  copyTitle: '复制“{{text}}”',
  copied: '已复制',
  copy: '复制',
  emptyCellTitle: '清空此单元格',
  clear: '清除',
  nothingMatchesShorter: '没有匹配项 — 请尝试更短的词。',
  otherChoices: '其他选项',
  otherChoicesWith: '{{what}} 下的其他选项',
  pickingClears: '选择后将清除{{fields}}',
  andJoin: '、',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "failed": "Échec ({{status}})",
  "loadFailed": "Échec du chargement ({{status}})",
  "saveFailed": "Échec de l'enregistrement ({{status}})",
  "couldNotAdd": "Impossible d'ajouter ({{status}})",
  "couldNotChangeItem": "Impossible de modifier l'article ({{status}})",
  "couldNotAttach": "Impossible de rattacher ({{status}})",
  "couldNotMark": "Impossible de le marquer ({{status}})",
  "couldNotRemove": "Impossible de supprimer ({{status}})",
  "rowWord": "ligne",
  "attachSummary": "{{done}} rattachée(s) ; {{failed}} n'ont pas pu l'être : {{list}}",
  "gapDiff": "La ligne enregistre {{stored}} pcs, mais les cases horaires totalisent {{sum}} pcs. À vérifier.",
  "gapOpening": "Solde d'ouverture reporté du fichier Capacity Management : {{stored}} pcs.\nCe n'est pas la production du jour, il n'est donc pas ajouté au total du jour — mais Capacity le compte quand même comme fabriqué.",
  "gapNoHours": "Cette ligne enregistre {{stored}} pcs SANS détail horaire, elle ne fait donc pas partie du total du jour.\nRenseignez les cases horaires pour que le chiffre soit compté.",
  "chkNotAddUp": "Ne concorde pas",
  "chkOpening": "Solde d'ouverture",
  "chkNoHourly": "Pas de détail horaire",
  "chkUnmatched": "Lignes non rattachées",
  "daysWithNothing_one": "{{count}} jour sans rien",
  "daysWithNothing_other": "{{count}} jours sans rien",
  "stepMonth": "Expédition du mois",
  "colMonth": "Mois",
  "colPo": "PO#",
  "colDescription": "Description",
  "colColour": "Couleur",
  "colSkinCase": "Skin/Case",
  "colOrder": "Commande",
  "colLine": "Ligne n°",
  "colWorkers": "Ouvriers",
  "colHrs": "H",
  "colTotal": "Total",
  "colRemain": "Reste",
  "colEff": "Eff.",
  "choose": "Choisir",
  "loading": "Chargement…",
  "nothingLeft": "Plus rien à choisir ici.",
  "blank": "(vide)",
  "leftOf": "{{left}} restant sur {{order}}",
  "destinations": "{{n}} destinations",
  "unTitle": "Non rattaché à une commande",
  "unRows": "{{total}} lignes",
  "unItems": "{{n}} articles",
  "unItemsOf": "{{shown}} / {{n}} articles",
  "unLargest": "(affichage des {{n}} plus importants)",
  "clearFilterTitle": "Effacer le filtre",
  "filteredBtn": "filtré",
  "unNote": "Production bien présente dans le fichier de l'usine mais que le portail n'a pas pu rattacher à une commande. Rien n'est deviné : la rattacher à la mauvaise commande ajouterait les heures au mauvais travail.",
  "nothingUnmatched": "Plus rien de non rattaché.",
  "colVendor": "Fournisseur",
  "colFileDescription": "Description dans le fichier de l'usine",
  "colWhy": "Raison de l'absence de correspondance",
  "colPcs": "pcs",
  "colDays": "Jours",
  "colLastSeen": "Dernière apparition",
  "markDealtWith": "Marquer comme traité",
  "nothingMatchesFilter": "Rien ne correspond à ce filtre.",
  "sheetsTitle": "Feuilles remplies",
  "sheetDays_one": "{{count}} jour",
  "sheetDays_other": "{{count}} jours",
  "sheetMonths_one": "{{count}} mois",
  "sheetMonths_other": "{{count}} mois",
  "issuesTitle": "Uniquement les jours contenant une ligne qui ne concorde pas, ou un chiffre sans détail horaire",
  "issuesOnlyOn": "uniquement ce qui est à vérifier",
  "issuesCount": "à vérifier · {{n}}",
  "noSheets": "Ce fournisseur n'a pas encore rempli de feuille.",
  "colDate": "Date",
  "colRows": "Lignes",
  "colOutput": "Production",
  "colWorkHours": "Heures de travail",
  "colLines": "Lignes",
  "colNeedsChecking": "À vérifier",
  "colSinceBefore": "Depuis la feuille précédente",
  "colEnteredBy": "Saisi par",
  "todayTag": "aujourd'hui",
  "gapMarkTitle": "{{rows}} ligne(s) enregistrent ensemble {{qty}} pcs sans détail horaire, elles ne figurent donc pas dans la colonne Production.",
  "gapMarkAllOpening": "Il s'agit entièrement du solde d'ouverture reporté du fichier Capacity Management.",
  "gapMarkOpening_one": "{{count}} ligne · {{qty}} pcs de solde d'ouverture",
  "gapMarkOpening_other": "{{count}} lignes · {{qty}} pcs de solde d'ouverture",
  "gapMarkNoHourly_one": "{{count}} ligne · {{qty}} pcs sans détail horaire",
  "gapMarkNoHourly_other": "{{count}} lignes · {{qty}} pcs sans détail horaire",
  "diffTitle": "{{n}} ligne(s) enregistrent un total qui ne correspond pas à la somme des cases horaires.",
  "diffText_one": "{{count}} ligne ne concorde pas",
  "diffText_other": "{{count}} lignes ne concordent pas",
  "unmarkTitle": "{{n}} ligne(s) du fichier de l'usine pour ce jour, {{qty}} pcs, n'ont pas pu être rattachées à une commande — voir Non rattachées.",
  "unmarkText": "{{n}} non rattachée(s) · {{qty}} pcs",
  "title": "Production quotidienne",
  "intro": "Ce que chaque ligne a produit, heure par heure. Choisissez l'article dans la liste des commandes — la description, la couleur et la quantité proviennent alors de Helinox, ce qui place les chiffres au bon endroit.",
  "chooseVendor": "Choisir un fournisseur…",
  "notLinked": "Ce compte n'est pas encore lié à un fournisseur, il n'y a donc rien à afficher.",
  "chooseVendorToSee": "Choisissez un fournisseur pour voir sa production.",
  "todayBtn": "Aujourd'hui",
  "sheetsBtnTitle": "Les jours pour lesquels ce fournisseur a rempli une feuille",
  "checkBtnTitle": "Ce qui, dans les lignes de ce fournisseur, ne permet pas de mesurer — pièces sans heures, heures d'une ligne dépassant une journée, heures réparties uniformément — et ce qu'il faut corriger en premier",
  "checkBtn": "Contrôle des données",
  "hourBoxesAdded": "somme des cases horaires",
  "rowsN_one": "{{count}} ligne",
  "rowsN_other": "{{count}} lignes",
  "workHoursN": "{{n}} heures de travail",
  "filteredClear": "Filtré — effacer",
  "sortedClear": "Trié — effacer",
  "unNoteTitle": "Lignes du fichier de l'usine pour ce jour qui n'ont pas pu être rattachées à une commande.\nElles sont affichées en rouge sous la feuille et ne sont PAS dans le total ci-dessus. Déverrouillez le tableau pour en rattacher une à une commande, ou marquez-la comme traitée.",
  "unNoteText": "{{n}} non rattachée(s) · {{qty}} pcs, sous la feuille",
  "attachAllTitle": "Rattacher chaque ligne non rattachée dont les cinq cellules sont remplies, à la commande indiquée par ses cellules.\nVérifiez d'abord les cellules bleues (devinées) — rien n'est écrit tant que vous n'appuyez pas ici.",
  "attaching": "Rattachement…",
  "attachFilled_one": "Rattacher {{count}} ligne remplie",
  "attachFilled_other": "Rattacher {{count}} lignes remplies",
  "earlierMore": "{{dates}} et {{n}} autres",
  "earlierDays_one": "{{count}} jour antérieur est à vérifier",
  "earlierDays_other": "{{count}} jours antérieurs sont à vérifier",
  "gapNoteTitle": "Le total du jour est la somme des cases horaires.\nCes lignes enregistrent un chiffre sans détail horaire, il n'est donc PAS dans le total. Renseignez les cases horaires pour qu'il soit compté.",
  "gapNote_one": "{{count}} ligne sans détail horaire · {{qty}} pcs non comptés",
  "gapNote_other": "{{count}} lignes sans détail horaire · {{qty}} pcs non comptés",
  "openingParen": "(solde d'ouverture)",
  "editTableTitle": "Déverrouillez le tableau, modifiez autant que vous voulez, puis enregistrez en une seule fois",
  "editTable": "Modifier le tableau",
  "saving": "Enregistrement…",
  "saveTable": "Enregistrer le tableau",
  "saveTableN_one": "Enregistrer le tableau ({{count}} ligne)",
  "saveTableN_other": "Enregistrer le tableau ({{count}} lignes)",
  "cancel": "Annuler",
  "unmatchedBtnTitle": "Lignes du fichier de l'usine qui n'ont pas pu être rattachées à une commande",
  "unmatchedBtn": "Non rattachées",
  "reload": "Recharger",
  "bulkHint": "Le tableau est déverrouillé — saisissez librement, rien n'est écrit tant que vous n'appuyez pas sur <b>Enregistrer le tableau</b>. L'enregistrement se fait en une fois : tout est pris en compte ou rien ne change. Choisir un article sur une ligne vide ajoute cette ligne immédiatement.",
  "searchDescription": "Rechercher une description…",
  "inTheFile": "Dans le fichier",
  "notMatched": "Non rattaché",
  "chooseFirst": "Choisissez d'abord Mois, PO#, Description et Couleur",
  "filePo": "PO du fichier : {{po}}",
  "fileLabel": "Fichier : {{file}}",
  "pickAgainTitle": "Mauvais article ? Cliquez pour en choisir un autre — les heures sont conservées.",
  "confirmTypeHours": "Cette ligne enregistre {{qty}} pcs sans détail horaire.\nSaisir par heure remplace ce chiffre par la somme des cases horaires — renseignez donc toute la journée. Continuer ?",
  "opShort": "op",
  "removeRowTitle": "Supprimer cette ligne",
  "confirmRemove": "Supprimer {{what}} ({{part}}) du {{date}} ?",
  "confirmLeave": "{{n}} ligne(s) ont des modifications non enregistrées. Quitter ce jour les perdra. Continuer ?",
  "confirmDiscard": "Abandonner les modifications non enregistrées sur {{n}} ligne(s) ?",
  "confirmAttachAll": "Rattacher {{n}} ligne(s) à la commande indiquée sur chacune ?",
  "confirmAttachOver": "{{over}} d'entre elles dépassent ce qu'il reste sur leur commande.",
  "attachTitle": "Rattacher {{qty}} pcs à {{po}} · {{description}} · {{colour}} · {{part}}",
  "attachOverTitle": "Cette commande a encore {{left}} sur {{order}} — le rattachement la dépasse.",
  "attach": "Rattacher",
  "clearChosenTitle": "Effacer ce qui a été choisi sur cette ligne",
  "dismissTitle": "Traité, non rattaché — pour une ligne qui n'appartient à aucune commande. Elle quitte cette feuille et la liste Non rattachées et n'est PAS enregistrée comme production.",
  "clearLower": "effacer",
  "nothingEntered": "Rien de saisi pour le {{date}}.",
  "guessedLoose": "{{value}} — deviné à partir d'un nom proche, à vérifier",
  "guessedFile": "{{value}} — suggéré d'après le fichier du fournisseur",
  "thisCell": "Cette cellule",
  "copyTitle": "Copier « {{text}} »",
  "copied": "Copié",
  "copy": "Copier",
  "emptyCellTitle": "Vider cette cellule",
  "clear": "Effacer",
  "nothingMatchesShorter": "Aucune correspondance — essayez un mot plus court.",
  "otherChoices": "Autres choix",
  "otherChoicesWith": "Autres choix avec {{what}}",
  "pickingClears": "en choisir un efface {{fields}}",
  "andJoin": " et "
};
const ja = {
  "failed": "失敗しました（{{status}}）",
  "loadFailed": "読み込みに失敗しました（{{status}}）",
  "saveFailed": "保存に失敗しました（{{status}}）",
  "couldNotAdd": "追加できませんでした（{{status}}）",
  "couldNotChangeItem": "アイテムを変更できませんでした（{{status}}）",
  "couldNotAttach": "紐づけできませんでした（{{status}}）",
  "couldNotMark": "マークできませんでした（{{status}}）",
  "couldNotRemove": "削除できませんでした（{{status}}）",
  "rowWord": "行",
  "attachSummary": "{{done}} 件を紐づけました。紐づけできなかったもの {{failed}} 件：{{list}}",
  "gapDiff": "この行には {{stored}} pcs が保存されていますが、時間別の入力欄の合計は {{sum}} pcs です。確認してください。",
  "gapOpening": "Capacity Management ファイルから繰り越した期首残高：{{stored}} pcs。\nこれは当日の生産数ではないため日次合計には加算されませんが、Capacity では生産済みとして計上されます。",
  "gapNoHours": "この行には {{stored}} pcs が保存されていますが、時間別の内訳がないため日次合計に含まれません。\n時間別の入力欄に入力すると集計されます。",
  "chkNotAddUp": "合計が合わない",
  "chkOpening": "期首残高",
  "chkNoHourly": "時間別の内訳なし",
  "chkUnmatched": "未紐づけの行",
  "daysWithNothing_one": "入力なしの日が {{count}} 日",
  "daysWithNothing_other": "入力なしの日が {{count}} 日",
  "stepMonth": "月次出荷",
  "colMonth": "月",
  "colPo": "PO#",
  "colDescription": "品名",
  "colColour": "カラー",
  "colSkinCase": "Skin/Case",
  "colOrder": "注文",
  "colLine": "ライン #",
  "colWorkers": "作業人数",
  "colHrs": "時間",
  "colTotal": "合計",
  "colRemain": "残",
  "colEff": "効率",
  "choose": "選択",
  "loading": "読み込み中…",
  "nothingLeft": "ここで選択できるものはもうありません。",
  "blank": "（空白）",
  "leftOf": "{{order}} のうち残り {{left}}",
  "destinations": "{{n}} 仕向地",
  "unTitle": "注文に紐づいていないもの",
  "unRows": "{{total}} 行",
  "unItems": "{{n}} アイテム",
  "unItemsOf": "{{shown}} / {{n}} アイテム",
  "unLargest": "（上位 {{n}} 件を表示）",
  "clearFilterTitle": "フィルターを解除",
  "filteredBtn": "絞り込み中",
  "unNote": "工場のファイルには確かに存在する生産実績のうち、ポータルが注文に紐づけられなかったものです。推測はしていません。誤った注文に紐づけると、時間が別の作業に加算されてしまうためです。",
  "nothingUnmatched": "未紐づけのものはありません。",
  "colVendor": "仕入先",
  "colFileDescription": "工場ファイル上の品名",
  "colWhy": "一致しなかった理由",
  "colPcs": "pcs",
  "colDays": "日数",
  "colLastSeen": "最終確認日",
  "markDealtWith": "対応済みにする",
  "nothingMatchesFilter": "このフィルターに一致するものはありません。",
  "sheetsTitle": "入力済みシート",
  "sheetDays_one": "{{count}} 日",
  "sheetDays_other": "{{count}} 日",
  "sheetMonths_one": "{{count}} か月",
  "sheetMonths_other": "{{count}} か月",
  "issuesTitle": "合計が合わない行、または時間別の内訳がない数値を含む日のみ",
  "issuesOnlyOn": "要確認のみ",
  "issuesCount": "要確認 · {{n}}",
  "noSheets": "この仕入先はまだシートを入力していません。",
  "colDate": "日付",
  "colRows": "行数",
  "colOutput": "生産数",
  "colWorkHours": "作業時間",
  "colLines": "ライン",
  "colNeedsChecking": "要確認",
  "colSinceBefore": "前回シートからの経過",
  "colEnteredBy": "入力者",
  "todayTag": "今日",
  "gapMarkTitle": "{{rows}} 行で合計 {{qty}} pcs が保存されていますが、時間別の内訳がないため、生産数の列には含まれていません。",
  "gapMarkAllOpening": "すべて Capacity Management ファイルから繰り越した期首残高です。",
  "gapMarkOpening_one": "{{count}} 行 · 期首残高 {{qty}} pcs",
  "gapMarkOpening_other": "{{count}} 行 · 期首残高 {{qty}} pcs",
  "gapMarkNoHourly_one": "{{count}} 行 · 時間別の内訳なし {{qty}} pcs",
  "gapMarkNoHourly_other": "{{count}} 行 · 時間別の内訳なし {{qty}} pcs",
  "diffTitle": "{{n}} 行で、保存されている合計が時間別の入力欄の合計と一致していません。",
  "diffText_one": "合計が合わない行が {{count}} 件",
  "diffText_other": "合計が合わない行が {{count}} 件",
  "unmarkTitle": "この日の工場ファイルの {{n}} 行（{{qty}} pcs）を注文に紐づけられませんでした — 「未紐づけ」を確認してください。",
  "unmarkText": "未紐づけ {{n}} 件 · {{qty}} pcs",
  "title": "日次生産実績",
  "intro": "各ラインが時間ごとに生産した数量です。注文リストからアイテムを選ぶと、品名・カラー・数量が Helinox の情報から入るため、数値が正しい場所に入ります。",
  "chooseVendor": "仕入先を選択…",
  "notLinked": "このログインはまだ仕入先に紐づいていないため、表示するものがありません。",
  "chooseVendorToSee": "仕入先を選択すると、その生産実績が表示されます。",
  "todayBtn": "今日",
  "sheetsBtnTitle": "この仕入先がシートを入力した日",
  "checkBtnTitle": "この仕入先の行のうち計測に使えないもの（時間のない数量、1日を超えるラインの時間、均等に分割された時間）と、最初に修正すべきこと",
  "checkBtn": "データチェック",
  "hourBoxesAdded": "時間別入力欄の合計",
  "rowsN_one": "{{count}} 行",
  "rowsN_other": "{{count}} 行",
  "workHoursN": "作業時間 {{n}}",
  "filteredClear": "絞り込み中 — 解除",
  "sortedClear": "並べ替え中 — 解除",
  "unNoteTitle": "この日の工場ファイルの行のうち、注文に紐づけられなかったものです。\nシートの下に赤で表示され、上の合計には含まれません。テーブルのロックを解除して注文に紐づけるか、対応済みにしてください。",
  "unNoteText": "未紐づけ {{n}} 件 · {{qty}} pcs（シートの下）",
  "attachAllTitle": "5つのセルがすべて入力済みの未紐づけ行を、それぞれのセルが示す注文にまとめて紐づけます。\n先に青（推測）のセルを確認してください。このボタンを押すまで何も書き込まれません。",
  "attaching": "紐づけ中…",
  "attachFilled_one": "入力済みの {{count}} 行を紐づけ",
  "attachFilled_other": "入力済みの {{count}} 行を紐づけ",
  "earlierMore": "{{dates}} ほか {{n}} 件",
  "earlierDays_one": "それ以前の {{count}} 日に確認が必要です",
  "earlierDays_other": "それ以前の {{count}} 日に確認が必要です",
  "gapNoteTitle": "日次合計は時間別の入力欄の合計です。\nこれらの行には時間別の内訳がない数値が保存されているため、合計には含まれません。時間別の入力欄に入力すると集計されます。",
  "gapNote_one": "時間別の内訳がない行が {{count}} 件 · {{qty}} pcs は未集計",
  "gapNote_other": "時間別の内訳がない行が {{count}} 件 · {{qty}} pcs は未集計",
  "openingParen": "（期首残高）",
  "editTableTitle": "テーブルのロックを解除して自由に変更し、ワンクリックでまとめて保存します",
  "editTable": "テーブルを編集",
  "saving": "保存中…",
  "saveTable": "テーブルを保存",
  "saveTableN_one": "テーブルを保存（{{count}} 行）",
  "saveTableN_other": "テーブルを保存（{{count}} 行）",
  "cancel": "キャンセル",
  "unmatchedBtnTitle": "工場ファイルの行のうち、注文に紐づけられなかったもの",
  "unmatchedBtn": "未紐づけ",
  "reload": "再読み込み",
  "bulkHint": "テーブルのロックが解除されています — 自由に入力してください。<b>テーブルを保存</b>を押すまで何も書き込まれません。保存は一括で行われ、すべて反映されるか、何も変更されないかのどちらかです。空白行でアイテムを選ぶと、その行はすぐに追加されます。",
  "searchDescription": "品名を検索…",
  "inTheFile": "ファイル内",
  "notMatched": "未紐づけ",
  "chooseFirst": "先に月、PO#、品名、カラーを選択してください",
  "filePo": "ファイルの PO：{{po}}",
  "fileLabel": "ファイル：{{file}}",
  "pickAgainTitle": "アイテムを間違えましたか？ クリックして選び直せます — 時間は保持されます。",
  "confirmTypeHours": "この行には {{qty}} pcs が保存されていますが、時間別の内訳がありません。\n時間別に入力すると、この数値は時間別の入力欄の合計に置き換わります — 1日分すべてを入力してください。続行しますか？",
  "opShort": "工程",
  "removeRowTitle": "この行を削除",
  "confirmRemove": "{{date}} の {{what}}（{{part}}）を削除しますか？",
  "confirmLeave": "{{n}} 行に未保存の変更があります。この日を離れると破棄されます。続行しますか？",
  "confirmDiscard": "{{n}} 行の未保存の変更を破棄しますか？",
  "confirmAttachAll": "{{n}} 行を、それぞれに表示されている注文に紐づけますか？",
  "confirmAttachOver": "そのうち {{over}} 件は、注文の残数量を超えます。",
  "attachTitle": "{{qty}} pcs を {{po}} · {{description}} · {{colour}} · {{part}} に紐づけ",
  "attachOverTitle": "この注文は {{order}} のうち残り {{left}} です — 紐づけると超過します。",
  "attach": "紐づけ",
  "clearChosenTitle": "この行で選択した内容をクリア",
  "dismissTitle": "対応済み（紐づけなし）— どの注文にも属さない行に使います。このシートと未紐づけ一覧から外れ、生産実績としては記録されません。",
  "clearLower": "クリア",
  "nothingEntered": "{{date}} の入力はありません。",
  "guessedLoose": "{{value}} — 似た名称から推測しました。確認してください",
  "guessedFile": "{{value}} — 仕入先のファイルから推奨",
  "thisCell": "このセル",
  "copyTitle": "「{{text}}」をコピー",
  "copied": "コピーしました",
  "copy": "コピー",
  "emptyCellTitle": "このセルを空にする",
  "clear": "クリア",
  "nothingMatchesShorter": "一致するものがありません — もっと短い語で試してください。",
  "otherChoices": "その他の選択肢",
  "otherChoicesWith": "{{what}}の他の選択肢",
  "pickingClears": "選択すると{{fields}}がクリアされます",
  "andJoin": "と"
};

const dictionary = { ns: 'xOutput', en, ko, vi, zh, fr, ja };

export default dictionary;
